import React, { useState, useMemo } from "react";
import { BaseModal } from "../../../atoms/base-modal";
import classnames from "classnames";
import {
  validateIpAddress,
  AddressSetting,
  displayIpAddress,
} from "../../../../application/domain/acl";
import { TextField } from "@graffer-inc/console-design-kit";

interface OrganizationAclModalProps {
  isLoading: boolean;
  updateTarget?: AddressSetting;
  isActive: boolean;
  onAddIP: (setting: AddressSetting) => void;
  onUpdateIP: (setting: AddressSetting) => void;
  onModal: () => void;
}

export const OrganizationAclModal: React.FunctionComponent<
  OrganizationAclModalProps
> = ({ isLoading, updateTarget, isActive, onModal, onAddIP, onUpdateIP }) => {
  const [ipAddress, setIpAddress] = useState(
    updateTarget ? displayIpAddress(updateTarget) : "",
  );
  const [remarks, setRemarks] = useState(updateTarget?.remarks || "");
  const isUpdate = !!updateTarget;

  const onClose = () => {
    setIpAddress("");
    setRemarks("");
    onModal();
  };

  const onSubmit = () => {
    const setting: AddressSetting = {
      ipAddress: ipAddress,
      remarks: remarks,
    };
    if (isUpdate) {
      onUpdateIP(setting);
    } else {
      onAddIP(setting);
    }
    onClose();
  };

  const isInvalidIpAddress = useMemo(() => {
    return !validateIpAddress(ipAddress);
  }, [ipAddress]);

  return (
    <BaseModal
      isActive={isActive}
      title={isUpdate ? "IPアドレスを更新する" : "IPアドレスを追加する"}
      onClose={onClose}
    >
      <section className="modal-card-body">
        <div className="field">
          <TextField
            label="IPアドレス"
            description=""
            placeholder="192.0.2.1 or 192.168.10.0/24"
            value={ipAddress}
            onChange={(e) => setIpAddress(e.target.value)}
            errorMessages={
              isInvalidIpAddress ? "IPアドレスが正しくありません" : ""
            }
            required
          />
        </div>
        <div className="field">
          <TextField
            label="コメント"
            description=""
            placeholder="○○市役所庁舎グローバルIP（１）"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          />
        </div>
      </section>
      <footer className="modal-card-foot">
        <button className="button is-failure is-fullwidth" onClick={onClose}>
          キャンセル
        </button>
        <button
          className={classnames("button is-info is-fullwidth", {
            "is-loading": isLoading,
          })}
          onClick={onSubmit}
          disabled={isInvalidIpAddress}
        >
          {isUpdate ? "更新する" : "追加する"}
        </button>
      </footer>
    </BaseModal>
  );
};
